import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import Radio from '@/components/radio/Radio';
import { setOverviewOperationStatistics } from '@/store/slices/components/dashboard/DashboardSlice';
import { PROPERTY_OPERATIONS } from '@/components/Dashboard/constants';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from '../totalValueCard.module.scss';

export default function RadioSelector() {
  const { selectedOperation } = useSelector(
    (state) => state.DashboardSlice.overviewOperationStatistics
  );
  const dispatch = useDispatch();

  const handleClick = (operation) => {
    dispatch(
      setOverviewOperationStatistics({
        key: 'selectedOperation',
        value: operation,
      })
    );
  };

  return (
    <Box className={styles.operationsWrapper}>
      <Box
        as="button"
        className={styles.operation}
        onClick={() => handleClick(PROPERTY_OPERATIONS.SALE)}
        data-checked={selectedOperation === PROPERTY_OPERATIONS.SALE}
      >
        <Radio
          checked={selectedOperation === PROPERTY_OPERATIONS.SALE}
          readOnly
        />
        <Text className={styles.operationText}>
          {Trans(translations, 'Sale')}
        </Text>
      </Box>
      <Box
        as="button"
        className={styles.operation}
        onClick={() => handleClick(PROPERTY_OPERATIONS.RENT)}
        data-checked={selectedOperation === PROPERTY_OPERATIONS.RENT}
      >
        <Radio
          checked={selectedOperation === PROPERTY_OPERATIONS.RENT}
          readOnly
        />
        <Text className={styles.operationText}>
          {Trans(translations, 'Rent')}
        </Text>
      </Box>
    </Box>
  );
}
